<app-header (showMenu)="getShowMenuEvent()" [isSmallScreen]="smallScreen" [showMenuStatus]="showSideMenu"></app-header>
<app-side-nav (navigatedAction)="getNavigatedAction()" *ngIf="!smallScreen || showSideMenu"></app-side-nav>
<router-outlet></router-outlet>
